export default "__VITE_ASSET__d05ea294__"